enum MODE {
  view = 'view',
  select = 'select',
  compare = 'compare',
}

export default MODE;
